import React from "react";

function Button({ children, className = "", type = "button", ...props }) {
  return (
    <button
      type={type}
      {...props}
      className={`inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md focus:outline-none transform transition-transform duration-200 ease-in-out hover:bg-blue-700 hover:scale-105 hover:shadow-lg focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${className}`}
    >
      {children}
    </button>
  );
}

export { Button };
export default Button;
